import { bbox } from 'ol/loadingstrategy';
import type VectorSource from 'ol/source/Vector';
import { type IMapLayerSource } from '../../../layers/MapLayer.ts';
import { createLayerVectorSource } from '../../../layers/vector/createLayerVectorSource.ts';

/**
 * VectorSource per identify, intersezione e competenza: stesse sorgenti
 * per-protocollo del rendering, ma con caricamento per bounding box
 * (compatibile con `loadFeatures(extent, ...)`).
 *
 * Config incompleta o tipo non vettoriale → `null`, e il chiamante salta il
 * layer. Una source vuota avrebbe un loader che non emette mai
 * `featuresloadend`, e il caricamento non si chiuderebbe.
 */
export function createIntersectionVectorSource(
  intersection?: IMapLayerSource,
): VectorSource | null {
  return createLayerVectorSource(intersection, { strategy: bbox });
}
